import $ from "jquery";
import {Modal} from "bootstrap";
import 'select2';
import 'select2/dist/css/select2.min.css';
import {log} from "qrcode/lib/core/galois-field";
import Twig from "twig";
import {fetchStaffs} from "../services/staff";

let occupationModal = null;
export async function  openAppointmentModal(event,type)
{
    console.log(event);
    let self = this;
    $('.modal.fade').remove();
    $('#check-'+event.params.idtd).prop('checked', false);
    let timeFrom = new Date(Number(event.params.timefrom));
    let timestampFrom = event.params.timefrom;
    let timestampTo = Number(timestampFrom) + 60 * 60 * 1000;
    let doctorAppointment = timeFrom.toLocaleDateString("ru-KZ",{weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: "2-digit",
        minute: "2-digit"}
    );
    let timeStart = timeFrom.toLocaleTimeString("ru-KZ", {hour: "2-digit",minute: "2-digit"});
    let timeEnd = new Date(timestampTo).toLocaleTimeString("ru-KZ", {hour: "2-digit",minute: "2-digit"});

    this.minClientAge = event.params.patientage;

    $('#datatableDoctorOrderInfo-'+event.params.idtd).after( await generateAppointmentModal(event, timeStart, timeEnd, timestampFrom, timestampTo, doctorAppointment, this.minClientAge,type))


    $(`#appointmentModal-${event.params.id} .btn-close`).click(function (e){
        occupationModal.hide();
        $('#appointmentModal-'+event.params.id).remove();
        self.tableSchedule?.draw()
    });


    $('#orderServiceListModal').on('change', function (){
        let valueSelect = $(this).val();

        let addMinutes = global.globalFuncs.DiagnosticTypes.getDiagnosticMinuteByKey(valueSelect);
        let timeEndResult = Number(timestampFrom) + addMinutes * 60 * 1000
        $('#timeEnd').text(new Date(timeEndResult).toLocaleTimeString("ru-KZ", {hour: "2-digit",minute: "2-digit"}));
        $('#order-datetime-to').val(timeEndResult);

    })
    occupationModal = new Modal(document.getElementById('appointmentModal-' + event.params.id +''));
    occupationModal.show();

    const doctorOrderForm    = $("#doctorOrderForm");
    const orderDateTime      = $('#order-datetime');
    const clientPhoneAlert     = $('#clientPhoneAlert');
    const invalidManagerAlertField     = $('#invalidManagerAlertField');
    const clientPhone        = $('#clientPhone');
    const clientBirthdayInput        = $('#clientBirthday');
    let orderDateCurrent     = new Date();
    const orderBtn           = $('#order-btn');
    const appointmentManagerInput = $('#appointment_manager');

    clientPhone.mask('+7 (000) 000-00-00');

    $.datetimepicker.setLocale('ru');
    clientBirthdayInput.datetimepicker({
        timepicker:false,
        format:'d.m.Y',
        maxDate:'0',
        onChangeDateTime:  self.clientAge
    });

    clientPhone.on('blur', function () {
        api.checkToken();
        let phone = clientPhone.val().replace(/\D/g, "");
        if (phone.length < 11){
            clientPhone.addClass('is-invalid');
            clientPhoneAlert.addClass('is-invalid');
            return
        }
        clientPhone.removeClass('is-invalid');
        clientPhoneAlert.removeClass('is-invalid');

        let result = api.searchClient(phone);
        if(result.status !== 200) {
            alert('Не получены данные из WEB. Повторите попытку позже или заполните поля самостоятельно');
        }
        if (result.length !== 0) {
            $('#clientName').val(result[0].CariAd);
            $('#clientSurname').val(result[0].CariSoyad);
            if (result[0].DogTar !== ''){
                let clientDateBirth = new Date(result[0].DogTar).toLocaleDateString("ru-KZ",{ timeZone: "Asia/Almaty" });
                clientBirthdayInput.val(clientDateBirth).change();
                clientAge()
            }
        } else {
            alert('Данных нет. Пожалуйста, заполните поля самостоятельно');
        }
    })

    clientBirthdayInput.on('change',function () {
        clientAge();
    });

    function clientAge(){
        let dateNow = new Date();
        dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        let clientBirthday = clientBirthdayInput.val();
        if (clientBirthday !== ''){
            clientBirthday = clientBirthday.split(".");
            clientBirthday = new Date(clientBirthday[2], clientBirthday[1] - 1, clientBirthday[0]);
            clientBirthday = new Date(clientBirthday.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate());
            let clientBirthdayNow = new Date(dateNow.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate()); //Birthday in the current year

            let age;
            age = dateNow.getFullYear() - clientBirthday.getFullYear();
            if (dateNow < clientBirthdayNow) {
                age = age-1;
            }

            $('#clientAge').val(age);
        } else {
            $('#clientAge').val('');
        }
    }


    /* отправляем данные */
    orderBtn.click(function () {
        // orderBtn.html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="loader-orderBtn"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>').attr('disabled', 'disabled');

        let validItemNoEmpty = true;

        //проверяем все поля на пустоту
        $('#doctorOrderForm .order-validation').each((item, element) => {
            if (element.value === '') {
                $('#clientEmptyStringsAlert').addClass('is-invalid');
                element.classList.add('is-invalid');
                validItemNoEmpty = false;
            } else {
                $('#clientEmptyStringsAlert').removeClass('is-invalid');
                element.classList.remove('is-invalid');
            }
        });

        if (appointmentManagerInput.val() === '') {
            invalidManagerAlertField.addClass('is-invalid');
            validItemNoEmpty = false;
        }else{
            invalidManagerAlertField.removeClass('is-invalid');
        }

        if ($('#orderServiceListModal option:selected').val() === "") {
            $('#orderServiceListModal').addClass('is-invalid');
            validItemNoEmpty = false;
        } else {
            $('#orderServiceListModal').removeClass('is-invalid');
        }

        if (validItemNoEmpty) {
            //проверяем телефон на количество знаков
            let clientPhoneVal = clientPhone.val().replace(/[^0-9]/g, '')
            if (clientPhoneVal.length !== 11) {
                clientPhone.addClass('is-invalid');
                clientPhoneAlert.addClass('is-invalid');
                validItemNoEmpty = false;
            } else {
                clientPhone.removeClass('is-invalid');
                clientPhoneAlert.removeClass('is-invalid');
            }

            //проверяем возраст пациента
            let patientAge = Number($('#clientAge').val());
            if (patientAge < self.minClientAge) {
                clientBirthdayInput.addClass('is-invalid');
                $('#clientAgeAlert').addClass('is-invalid');
                validItemNoEmpty = false;
            } else {
                clientBirthdayInput.removeClass('is-invalid');
                $('#clientAgeAlert').removeClass('is-invalid');
            }
        }

        if (!validItemNoEmpty) {
            orderBtn.attr('disabled', false).html('Записать');
            return
        }

        //если проходим все проверки, собираем инфо в json
        let clientEmail = $('#clientEmail').val();
        let formDataInfo = {};
        formDataInfo.info = {};
        formDataInfo['orderServiceList'] = $('#orderServiceListModal option:selected').val();
        formDataInfo['doctorId'] = $('#order-doctor').val();
        if (clientEmail !== ''){
            formDataInfo['clientEmail'] = clientEmail;
        }
        doctorOrderForm.find('input.order-validation').each(function () {
            formDataInfo[this.name] = $(this).val();
        });
        doctorOrderForm.find('.order-validation-info').each(function () {
            formDataInfo["info"][this.name] = $(this).val();
        })

        formDataInfo['positivId'] = "82";
        formDataInfo.clientPhone = formDataInfo.clientPhone.replace(/[^0-9]/g, '');
        formDataInfo.info.comment = formDataInfo.info.comment.replace(/[^a-zа-яё0-9\s]/gi, '');

        formDataInfo.info.salon_id = event.params.salonId
        console.log(formDataInfo.info.salon_id);
        //проверяем в реальном времени свободен ли врач на выбранное время
        let checkOccupation = api.getOccupation(formDataInfo.doctorId,formDataInfo.orderDateTimeFrom,formDataInfo.orderDateTimeTo);
        if (checkOccupation.Status === 200){
            for(let time in checkOccupation.object){
                if(!checkOccupation.object[time].includes("salonId")){
                    $('#appointmentModal-'+formDataInfo.doctorId+' .modal-body').prepend('' +
                        '<div class="alert alert-warning  alert-order-desktop">' +
                        '<p>Врач уже занят в это время.</p>' +
                        '<p>Пожалуйста, измените дату и время приема.</p>' +
                        '</div>'
                    );
                    setTimeout(function () {
                        occupationModal.hide();
                        self.tableSchedule.draw();
                    }, 5000);

                    return;
                }
            }

            if (appointmentManagerInput.val()){
                formDataInfo.info.manager = appointmentManagerInput.val();
            }

            $.ajax({
                method: 'post',
                url: global.api_url + '/schedule',
                contentType: "application/json",
                data: JSON.stringify(formDataInfo),
                format: 'json',
                dataType: 'json',
                async: false,
                success: function (result) {
                    orderBtn.html('Записать');
                    if (result.Status === 200) {
                        occupationModal.hide();
                        self.tableSchedule.draw();
                    }
                },
                error(error) {
                    console.debug(error);
                    $('#appointmentModal-'+formDataInfo.doctorId+' .modal-body').prepend('' +
                        '<div class="alert alert-warning  alert-order-desktop">' +
                        '<p>Что-то пошло не так.</p>' +
                        '<p>Пожалуйста, попробуйте отправить заявку чуть позже еще раз.</p>' +
                        '</div>'
                    );
                    setTimeout(function () {
                        occupationModal.hide();
                        self.tableSchedule.draw();
                    }, 5000);

                }
            })
        } else {
            $('#appointmentModal-'+formDataInfo.doctorId+' .modal-body').prepend('' +
                '<div class="alert alert-warning  alert-order-desktop">' +
                '<p>Что-то пошло не так.</p>' +
                '<p>Пожалуйста, попробуйте отправить заявку чуть позже еще раз.</p>' +
                '</div>'
            );
            setTimeout(function () {
                occupationModal.hide();
                self.tableSchedule.draw();
            }, 5000);
        }
        //END проверяем в реальном времени свободен ли врач на выбранное время
    })  /* END  orderBtn.click(function () */


    $('.jq-select-ui').select2({
        placeholder: "Выберите менеджера",
        dropdownParent: $("#appointmentModal-"+event.params.id),
        allowClear: true,
        language: "ru",
        width: '100%'
    });

}
async function generateAppointmentModal(event, timeStart, timeEnd, timestampFrom, timestampTo, doctorAppointment, minClientAge,type) {
    const diagnostics = Object.values(
        global.globalFuncs.DiagnosticTypes.getDiagnosticTypes()
    );

    diagnostics.sort(
        (a, b) => (a.sort_order_staff_form ?? 0) - (b.sort_order_staff_form ?? 0)
    );

    let optionsHtml = '<option value="">Выбрать</option>';

    for (const diagnostic of diagnostics) {
        optionsHtml += `<option value="${diagnostic.code}">${diagnostic.title}</option>`;
    }
    const staffs = await fetchStaffs({type: 'consul'});

    let optionsStaffHtml = '<option value="">Выбрать</option>';
    for (const staff of staffs.data) {
        optionsStaffHtml += `<option value="${staff.staff_id}">${staff.description.name}</option>`;
    }

    let optionsVisitHtml = '';

    const visitTypes = global.globalFuncs.ScheduleVisit.getVisitTypes();

    for (const key in visitTypes) {
        let selected = '';
        if (key === global.WhoIs.StaffID)
            selected = 'selected';
        optionsVisitHtml += `<option ${selected} value="${key}">${visitTypes[key].title}</option>`;
    }

    let managerSelectHtml;

    if (type === 'doctor'){
         managerSelectHtml =
            `
                <input type="hidden" id="appointment_manager" value="${global.WhoIs.StaffID}" name="appointment_manager" required>
        `
    }else{
         managerSelectHtml =
            `
        <div class="appointment__item" style="width:100%;">
            <label for="appointment_manager">* Менеджер</label>
            <select class="form-control form-control-sm jq-select-ui" name="appointment_manager"
                    id="appointment_manager" required>
                ${optionsStaffHtml}
            </select>
            <div className="invalid-feedback" id="invalidManagerAlertField">Нужно выбрать менеджера</div>
    
        </div>
        `
    }


    return `
        <div class="modal fade" id="appointmentModal-${event.params.id}" tabindex="-1" aria-hidden="true" aria-labelledby="exampleModalLabel">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">${doctorAppointment}</h5>
                        <button type="button" class="btn-close" aria-label="Close""></button>
                    </div>
                    <div class="modal-body appointmentModal">
                        <div class="appointmentModal__doctorInfo">
                            <strong>Салон ${event.params.salon}. Прием с ${timeStart} по <span id="timeEnd">${timeEnd}</span></strong>
                            <strong class="appointmentModal__doctorInfoName">${event.params.name}</strong>
                            <span>Минимальный возраст пациента: ${minClientAge}</span>
                        </div>
                        <form id="doctorOrderForm">
                            <input class="order-validation-doctor" type="hidden" id="order-doctor" value="${event.params.id}" name="doctorId" readonly>
                            <input class="order-validation-info" type="hidden" value="${global.WhoIs.StaffID}" name="manager">
                            <input type="hidden" id="order-datetime-from" value="${timestampFrom}" name="orderDateTimeFrom" class="order-validation" readonly>
                            <input type="hidden" id="order-datetime-to" value="${timestampTo}" class="order-validation" name="orderDateTimeTo" readonly>
                            <p><b>*</b> - поля, обязательные для заполнения</p>
                            <div class="form-group form-group--orderPatient">
                                <div class="appointment__item">
                                    <label for="orderServiceListModal">* Услуга</label>
                                    <select class="form-control form-control-sm" name="orderServiceList" id="orderServiceListModal" required>
                                        ${optionsHtml}
                                    </select>
                                </div>
                                <div class="appointment__item">
                                    <label for="orderServiceListVisitModal">* Прием</label>
                                    <select class="form-control form-control-sm order-validation-info" name="visit" id="orderServiceListVisitModal" required>
                                        ${optionsVisitHtml}
                                    </select>
                                </div>
                                ${managerSelectHtml}
                                <div class="appointment__item" style="width: 100%">
                                    <label for="orderServiceListVisitModal">Комментарий</label>
                                    <input type="text" class="form-control form-control-sm order-validation-info" name="comment" id="orderServiceListCommentModal" maxlength="50">
                                </div>
                                <div class="col-sm-12 mb-1">
                                    <div class="appointment__item">
                                        <label for="clientPhone">* Номер телефона</label>
                                        <input type="tel" name="clientPhone" placeholder="+7 (XXX) XXX-XX-XX" id="clientPhone" class="form-control form-control-sm order-validation" inputmode="text" required>
                                    </div>
                                    <div class="invalid-feedback" id="clientPhoneAlert">Неправильный формат номера телефона</div>
                                </div>
                                <div class="appointment__item">
                                    <label for="clientName">* Имя пациента</label>
                                    <input type="text" class="form-control form-control-sm order-validation" id="clientName" placeholder="Имя пациента" name="clientName" required>
                                </div>
                                <div class="appointment__item">
                                    <label for="clientSurname">* Фамилия пациента</label>
                                    <input type="text" class="form-control form-control-sm order-validation" id="clientSurname" placeholder="Фамилия пациента" name="clientSurname" required>
                                </div>
                                <div class="appointment__item">
                                    <label for="clientBirthday">* Дата рождения</label>
                                    <input type="text" class="form-control form-control-sm order-validation" name="clientDateBirth" required id="clientBirthday" placeholder="ДД.ММ.ГГГГ">
                                </div>
                                <div class="appointment__item">
                                    <label for="clientAge">* Возраст</label>
                                    <input type="text" class="form-control form-control-sm order-validation-info" name="clientAge" required id="clientAge">
                                    <div class="invalid-feedback" id="clientAgeAlert">Доктор не принимает пациентов младше ${minClientAge} лет</div>
                                </div>
                                <div class="appointment__item">
                                    <label for="clientEmail">Email пациента</label>
                                    <input type="email" class="form-control form-control-sm" id="clientEmail" placeholder="Email пациента" name="clientEmail">
                                </div>
                            </div>
                            <div class="form-group mt-20">
                                <button type="button" class="btn btn-primary doctor-order-btn" id="order-btn">Записать</button>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
    `;
}



